import { Move } from "assets/icons/Common";
import { HorizontalLine } from "components/primitives";
import { TextArea } from "components/primitives/TextArea";
import { usePropChangedEffect } from "hooks/propChangedEffect";
import { useEffect, useRef } from "react";
import { WidgetFC } from "types/Widget";
import { isPowerPointLink } from "util/iframeUtils";

import { Container, EmbedButton, MoveIconBtn, Title, VideoContainer } from "./embed.styles";

interface GoogleSlidesContainerProps {
  link?: string;
  placeholder?: string;
  isShowPPT?: boolean;
  hasError?: boolean;
}

export const GoogleSlidesContainer: WidgetFC<GoogleSlidesContainerProps> = (props) => {
  const { state, setState, settings, setSetting, isSettingsOpen } = props;
  const checkSettings = useRef(true);

  useEffect(() => {
    if (checkSettings.current && props.settings?.data?.link) {
      setState({
        link: props.settings?.data.link,
      });
      checkSettings.current = false;
    }
  }, [props.settings]);

  const handleChange = (value: string) => {
    const currentState = {
      link: value,
      isShowVideo: false,
      hasError: false,
    };

    setState(currentState);

    if (isSettingsOpen) {
      setSetting("data", currentState);
    }
  };

  const handleShowVideo = () => {
    const isPPtxLink = isPowerPointLink(state.link ?? "");

    if (isPPtxLink) {
      setState({
        link: state.link,
        isShowPPT: true,
        hasError: false,
      });
    } else {
      setState({
        link: state.link,
        isShowPPT: false,
        hasError: true,
      });
    }
  };

  usePropChangedEffect(() => {
    if (isSettingsOpen) {
      setState({
        link: settings.data?.link,
        isShowPPT: settings.data?.isShowPPT,
        hasError: settings.data?.hasError,
      });
    }
  }, [settings?.data]);

  if (state.isShowPPT) {
    return (
      <VideoContainer>
        <iframe
          src={state.link}
          width="100%"
          height="600px"
          sandbox="allow-scripts allow-same-origin allow-top-navigation"
          title="file"
        />
        <MoveIconBtn Icon={Move} />
      </VideoContainer>
    );
  }

  return (
    <>
      <Container>
        <Title>Google Slides link</Title>
        <HorizontalLine width="100%" margin="0 auto 1.25rem" />
        <TextArea
          placeholder={state?.placeholder}
          onChange={handleChange}
          value={state.link || ""}
          classNames={`${state.hasError ? "animate__shakeX" : ""}`}
          hasError={Boolean(state.link) && state.hasError}
          errorMessage="You need to paste working code"
        />
        <EmbedButton
          type="button"
          color="var(--primary)"
          disabled={!state.link}
          onClick={handleShowVideo}
        >
          Embed
        </EmbedButton>
      </Container>
    </>
  );
};
